//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import { useSelector } from 'react-redux';

import { getIsNationalTreasureCampaignsEnabled } from '@campaigns/redux/getIsNationalTreasureCampaignsEnabled';
import { NavMenuItem } from '@legacy-components/nav3/navigation-menus/NavMenuItem';
import { NAV_MENU_ITEMS_TRACKING_ID } from '@legacy-components/nav3/navigation-menus/constants/NavMenuItemConstants';

import { NavGroup } from 'app/initialization/routing/stateHelpers';

export const CampaignsNav = () => {
  // TODO: PD-244314 - Remove feature flag when National Treasure Campaigns is fully released
  const isNationalTreasureCampaignsEnabled = useSelector(
    getIsNationalTreasureCampaignsEnabled,
  );

  if (!isNationalTreasureCampaignsEnabled) {
    return null;
  }

  return (
    <NavMenuItem
      activeNavGroup={NavGroup.CAMPAIGNS}
      state='campaigns'
      trackingId={NAV_MENU_ITEMS_TRACKING_ID.CAMPAIGNS_NAV}
    >
      Campaigns
    </NavMenuItem>
  );
};
